import type { OrderAttribute } from "@jti/magento";
import type { MagentoApiGetOrderAttributesQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

type MagentoApiOrderAttribute = NonNullable<
  NonNullable<MagentoApiGetOrderAttributesQueryResponse["getOrderAttributes"]>[number]
>;

const hasRequiredAttributeFields = (
  attribute: MagentoApiOrderAttribute | null | undefined
): attribute is MagentoApiOrderAttribute => Boolean(attribute?.code && attribute?.placement);

const normalizeOrderAttribute = (attribute: MagentoApiOrderAttribute): OrderAttribute => ({
  code: attribute.code ?? "",
  label: attribute.label ?? "",
  input_type: (attribute.input_type ?? "text") as OrderAttribute["input_type"],
  data_type: (attribute.data_type ?? "text") as OrderAttribute["data_type"],
  is_required: attribute.is_required ?? false,
  min_length: attribute.min_length ?? 0,
  max_length: attribute.max_length ?? 0,
  validate_regex: attribute.validate_regex ?? "",
  value: attribute.value ?? "",
  description: attribute.description ?? "",
  placeholder: attribute.placeholder ?? "",
  placement: attribute.placement as OrderAttribute["placement"],
  sort_order: attribute.sort_order ?? 0,
});

export const getOrderAttributesEndpoint = (builder: MagentoApiBuilder) => ({
  getOrderAttributes: builder.query<OrderAttribute[], void>({
    query: () => ({
      method: "getOrderAttributes",
      params: [],
    }),
    providesTags: [TAGS.ORDER_ATTRIBUTES],
    transformResponse: (baseQueryReturnValue: MagentoApiGetOrderAttributesQueryResponse) =>
      (baseQueryReturnValue.getOrderAttributes ?? []).filter(hasRequiredAttributeFields).map(normalizeOrderAttribute),
  }),
});
